import { defineMessages } from '@sm/intl';

export const CORPORATE_SIGNATURE_RESEARCH_ENDPAGE_COPY = defineMessages({
  PAGE_CTA_TEXT: {
    id: 'SurveyThanks.copy.CorporateSignatureResearchEndpagePageCtaText',
    defaultMessage: 'Read the report',
    description: '[Type: header][Vis: high] - Invites users to read the research report',
  },
  PAGE_HEADING: {
    id: 'SurveyThanks.copy.CorporateSignatureResearchEndpageHeading',
    defaultMessage: 'How to adapt in times of crisis',
    description: '[Type: header][Vis: high] - Attract user attention based on current world conditions',
  },
  PAGE_SUBHEADING: {
    id: 'SurveyThanks.copy.CorporateSignatureResearchEndpageSubheading',
    defaultMessage:
      'Learn the 2 traits that decide how well an organization will weather the pandemic. Read our exclusive research report, based on 3,000+ survey results.',
    description: '[Type: header][Vis: medium] - Summarizes and piques interest in the research report',
  },
});
export const COVID_NEAR_YOU_COPY = defineMessages({
  PAGE_CTA_TEXT: {
    id: 'SurveyThanks.copy.CovidNearYouPageCtaText',
    defaultMessage: 'Start survey',
    description: '[Type: header][Vis: high] - Invites users to take the health survey',
  },
  PAGE_HEADING: {
    id: 'SurveyThanks.copy.CovidNearYouPageHeading',
    defaultMessage: 'How are you feeling? Contribute your health status to help track the COVID-19 pandemic.',
    description: '[Type: header][Vis: high] - Appeal to users to contribute personal data to combat the pandemic',
  },
  PAGE_SUBHEADING: {
    id: 'SurveyThanks.copy.CovidNearYouPageSubheading',
    defaultMessage:
      "SurveyMonkey is partnering with COVID Near You, a team of epidemiologists and software developers at Harvard, Boston Children's Hospital and volunteers from the technology industry.",
    description:
      '[Type: header][Vis: medium] - Establish trust in Covid Near You by specifying who is on the Covid Near You team',
  },
  PRIVACY_NOTICE: {
    id: 'SurveyThanks.copy.CovidNearYouPrivacyNotice',
    defaultMessage:
      'SurveyMonkey is acting solely as a service provider to COVID Near You with respect to the above survey. For additional information regarding how SurveyMonkey treats personal information and data, please visit our <a href="{SurveyMonkeyPrivacyPolicyLink}">Privacy Notice</a>',
    description:
      "[Type: link][Vis: low] - Specify SurveyMonkey's role as a service provider and link to the general Privacy Notice",
  },
});
export const CX_ENDPAGE_COPY = defineMessages({
  PAGE_CTA_TEXT: {
    id: 'SurveyThanks.copy.CxEndpagePageCtaText',
    defaultMessage: 'Learn more',
    description: '[Type: header][Vis: high] - Invites users to GetFeedback homepage',
  },
  PAGE_HEADING: {
    id: 'SurveyThanks.copy.CxEndpageHeading',
    defaultMessage: 'Get a CX platform that takes you straight to insights',
    description: '[Type: header][Vis: high] - Pique interest in GetFeedback',
  },
  PAGE_SUBHEADING: {
    id: 'SurveyThanks.copy.CxEndpageSubheading',
    defaultMessage: 'Sync customer feedback with data from your CRM using GetFeedback.',
    description: '[Type: header][Vis: medium] - Explain GetFeedback capabilities',
  },
});
export const GIANCARLO_ENDPAGE_COPY = defineMessages({
  PAGE_CTA_TEXT: {
    id: 'SurveyThanks.copy.GiancarloEndpagePageCtaText',
    defaultMessage: 'Start here',
    description: '[Type: header][Vis: high] - Invites users to Giancarlo marketing page',
  },
  PAGE_HEADING: {
    id: 'SurveyThanks.copy.GiancarloEndpagePageHeading',
    defaultMessage: 'Ask. Listen. Act.',
    description: '[Type: header][Vis: high] - Encourage users to ask questions',
  },
  PAGE_SUBHEADING: {
    id: 'SurveyThanks.copy.GiancarloEndpagePageSubheading',
    defaultMessage: 'Making the right decision is tough. Learn how Giancarlo Esposito does it.',
    description: '[Type: header][Vis: medium] - Explain how Giancarlo uses SurveyMonkey',
  },
  TEXT_BANNER_CTA_TEXT: {
    id: 'SurveyThanks.copy.GiancarloEndpageTextBannerCtaText',
    defaultMessage: 'Watch the video',
    description: '[Type: header][Vis: high] - Invites users to watch the Giancarlo marketing video',
  },
  TEXT_BANNER_HEADING: {
    id: 'SurveyThanks.copy.GiancarloEndpageTextBannerHeading',
    defaultMessage: "Giancarlo Esposito has a message for today's business leaders",
    description: '[Type: header][Vis: high] - Pique interest in Giancarlo marketing page',
  },
});
export const GO_BEYOND_TEXT_BANNER_COPY = defineMessages({
  CTA_TEXT: {
    id: 'SurveyThanks.copy.GoBeyondTextBannerCtaText',
    defaultMessage: 'Visit Momentive',
    description: '[Type: header][Vis: high] - Invites users to Momentive homepage',
  },
  HEADING: {
    id: 'SurveyThanks.copy.GoBeyondTextBannerHeading',
    defaultMessage: 'Go beyond collecting feedback',
    description: '[Type: header][Vis: high] - Pique interest in Momentive',
  },
  SUBHEADING: {
    id: 'SurveyThanks.copy.GoBeyondTextBannerSubheading',
    defaultMessage:
      'Momentive, the maker of SurveyMonkey, offers solutions to help you drive change in your organization.',
    description: '[Type: header][Vis: medium] - Explain Momentive capabilities',
  },
});
export const MRX_ENDPAGE_COPY = defineMessages({
  PAGE_CTA_TEXT: {
    id: 'SurveyThanks.copy.MrxEndpagePageCtaText',
    defaultMessage: 'Learn more',
    description: '[Type: header][Vis: high] - Invites users to blog post about Allbirds using SurveyMonkey',
  },
  PAGE_HEADING: {
    id: 'SurveyThanks.copy.MrxEndpagePageHeading',
    defaultMessage: 'How Allbirds uses SurveyMonkey to track its explosive growth',
    description: '[Type: header][Vis: high] - Uses a popular brand to establish corporate trust.',
  },
  PAGE_SUBHEADING: {
    id: 'SurveyThanks.copy.MrxEndpageSubheading',
    defaultMessage: "Allbirds relies on SurveyMonkey market research to track its brand's expansion around the globe.",
    description: '[Type: header][Vis: medium] - Explains how Allbirds uses SurveyMonkey',
  },
});
export const POLLING_ENDPAGE_COPY = defineMessages({
  PAGE_CTA_TEXT: {
    id: 'SurveyThanks.copy.PollingEndpageCtaText',
    defaultMessage: 'Take the survey',
    description: '[Type: header][Vis: high] - Invites user to polling survey',
  },
  PAGE_HEADING: {
    id: 'SurveyThanks.copy.PollingEndpageHeading',
    defaultMessage: 'Where do you stand on current events? Share your opinion.',
    description: '[Type: header][Vis: high] - Encourages user to share opinions on current events in their area',
  },
});
export const POLLING_TEXT_BANNER_COPY = defineMessages({
  CTA_TEXT: {
    id: 'SurveyThanks.copy.PollingTextBannerCtaText',
    defaultMessage: 'See how',
    description: '[Type: header][Vis: high] - Invites users to SurveyMonkey homepage',
  },
  SUBHEADING: {
    id: 'SurveyThanks.copy.PollingTextBannerSubheading',
    defaultMessage:
      'More than 19 million users use SurveyMonkey to ask questions. Learn how you can use surveys to ask yours.',
    description: '[Type: header][Vis: medium] - Share the number of SurveyMonkey users to establish corporate trust',
  },
});
export const RACIAL_JUSTICE_ENDPAGE_COPY = defineMessages({
  PAGE_CTA_TEXT: {
    id: 'SurveyThanks.copy.RacialJusticeEndpagePageCtaText',
    defaultMessage: 'Learn more',
    description: '[Type: header][Vis: high] - Invites users to marketing page about diversity',
  },
  PAGE_HEADING: {
    id: 'SurveyThanks.copy.RacialJusticeEndpageHeading',
    defaultMessage: 'Get tools for addressing racial equity in the workplace',
    description: '[Type: header][Vis: high] - Appeal to interest in racial equity at work',
  },
  PAGE_SUBHEADING: {
    id: 'SurveyThanks.copy.RacialJusticeEndpageSubheading',
    defaultMessage:
      'Get survey templates, tools, and resources to start understanding the racial equity dynamics in your organization.',
    description: '[Type: header][Vis: medium] - Explain how SurveyMonkey can be used to address racial equity at work',
  },
});
export const STANDARD_ENDPAGE_DEFAULT_COPY = defineMessages({
  ENDPAGE_HEADER: {
    id: 'SurveyThanks.copy.StandardEndpageDefaultEndpageHeader',
    defaultMessage: 'Thank you for taking this survey.',
    description: '[Type: header][Vis: medium] - Informs the viewer that this survey has just completed',
  },
  LOGO_ARIA_LABEL: {
    id: 'SurveyThanks.copy.StandardEndpageDefaultHomepageLinkAriaLabel',
    defaultMessage: 'SurveyMonkey home',
    description: '[Type: label][Vis: low] - Aria label for SurveyMonkeyLogoWithTest link to support accessibility',
  },
  PRIVACY_NOTICE: {
    id: 'SurveyThanks.copy.StandardEndpageDefaultPrivacyNotice',
    defaultMessage: '<a href="{link}">SurveyMonkey Research Privacy Notice</a>',
    description: '[Type: link][Vis: low] - Text for link to SurveyMonkey Privacy Notice',
  },
});
export const UPENN_POLLING_ENDPAGE_COPY = defineMessages({
  PRIVACY_NOTICE: {
    id: 'SurveyThanks.copy.UPennPollingEndpageCopyPrivacyNotice',
    defaultMessage:
      'SurveyMonkey is acting solely as a service provider to University of Pennsylvania for this survey. Review UPenn\'s <a href="{UPennPrivacyPolicyLink}">Privacy Policy</a> to understand how they process your personal information. For more information on how SurveyMonkey treats personal information and data, visit SurveyMonkey\'s Privacy Notice <a href="{SurveyMonkeyPrivacyPolicyLink}">here</a>.',
    description:
      "[Type: link][Vis: low] - Explains the roles of SurveyMonkey in this survey and links to UPenn and SurveyMonkey's Privacy Notices",
  },
});
